const store = require("../store.js");
const FileTypeActions = require("../actions/FileTypeActions.js");

const dispatch = store.dispatch;

const Server = require("../Server.js");

const creators = {
    Get() {
        dispatch((thunkDispatch) => {
            thunkDispatch({
                type: FileTypeActions.Get
            });

            Server.Get("upload-type/current-user")
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    thunkDispatch({
                        type: FileTypeActions.Got,
                        Data: json
                    });
                })
                .catch((ex) => {
                    thunkDispatch({
                        type: FileTypeActions.GetErrored,
                        Error: ex
                    });
                });
        });
    },
    Select(fileType) {
        dispatch({
            type: FileTypeActions.Select,
            FileType: fileType
        });
    },
    DeSelect() {
        dispatch({
            type: FileTypeActions.DeSelect
        });
    }
};

module.exports = creators;


// WEBPACK FOOTER //
// ./src/actionCreators/FileTypeActionCreators.js